/** Backend identity only: never use a stored display-mode fallback for private course caches. */
export interface ContentWorkspaceSelf {
  employeeId?: string | number | null
  authUser?: { organization_id?: string | number | null; role?: string | null; is_admin?: boolean; chatbot_mode?: string | null }
}

export function contentWorkspaceScope(self: ContentWorkspaceSelf | null | undefined): string | null {
  const user = self?.authUser
  if (!self?.employeeId || !user?.organization_id || !user.role) return null
  return JSON.stringify([String(self.employeeId), String(user.organization_id), user.role, !!user.is_admin, user.chatbot_mode ?? 'user'])
}

export function contentWorkspaceKeys(scope: string, id: string | undefined) {
  return {
    record: ['content', id, 'workspace', scope] as const,
    items: ['contentItemsList', id, 'workspace', scope] as const,
    pages: ['contentPages', id, 'workspace', scope] as const,
    responses: ['contentResponses', id, 'workspace', scope] as const,
    response: (responseId: string) => ['contentResponse', id, responseId, 'workspace', scope] as const,
  }
}

export class ContentWorkspaceChanged extends Error {
  constructor() { super('Content workspace changed'); this.name = 'ContentWorkspaceChanged' }
}

export function assertContentWorkspace(isCurrent?: () => boolean) {
  if (isCurrent && !isCurrent()) throw new ContentWorkspaceChanged()
}

/** Guards completion and the next step in an async sequence; it cannot undo a request already sent. */
export function guardContentOperation<Args extends unknown[], Result>(isCurrent: () => boolean, operation: (...args: Args) => Promise<Result>) {
  return async (...args: Args): Promise<Result> => {
    if (!isCurrent()) throw new ContentWorkspaceChanged()
    const result = await operation(...args)
    if (!isCurrent()) throw new ContentWorkspaceChanged()
    return result
  }
}
